import OutcomeMapper from './outcome-mapper';

const OutcomeModel = {
    mapper: OutcomeMapper,

    odd: {
        fieldName: 'o',
        type: Number,
    },

    outcomeRefId: {
        fieldName: 'r',
        type: String,
    },

    shortCode: {
        fieldName: 'h',
        type: Number,
    },

    status: {
        fieldName: 's',
        type: Number,
    },
};

export default OutcomeModel;
